export function prependCanadaAndUSCountryCode(number: string): string {
    if (!number) return number;

    const raw: string = number.trim();

    // already in international format
    if (raw.startsWith('+1')) {
        return raw;
    }

    // keep only digits
    const digits: string = raw.replace(/\D/g, '');

    // if user entered 1 + 10 digits (e.g. 1XXXXXXXXXX), strip the leading 1
    if (digits.length === 11 && digits.startsWith('1')) {
        return '+1' + digits.slice(1);
    }

    // if exactly 10 digits, prefix +1
    if (digits.length === 10) {
        return '+1' + digits;
    }

    // fallback: if already starts with + keep original, otherwise prefix plus to digits
    if (raw.startsWith('+')) {
        return raw;
    }

    // last resort: prefix + to cleaned digits (may be invalid but avoids duplicate 1)
    return '+' + digits;
}
